import React from 'react';
import PropTypes from 'prop-types';
import { Text, RichText, Image, withSitecoreContext, isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import Button from '../shared/Button/Button.jsx';
import PromoHeroWrapper from './PromoHero.styles';
import { Content, TopHeadingWrapper, SubHeadingWrapper, CopyWrapper, CopyDiv, MediaDiv } from './PromoHero.styles';

const PromoHero = ({ sitecoreContext, fields = {}, params = {} }) => {
  const { site, trademarkReplacements = [] } = sitecoreContext;
  const experienceEditor = isEditorActive();
  const {
    topHeading,
    subHeading,
    copy,
    button,
    backgroundImage,
    foregroundImage
  } = fields;

  const {
    componentclass = 'promo-hero',
    id = null,
  } = params;

  return (
    <PromoHeroWrapper
      backgroundImage={fields?.backgroundImage?.value?.src}
      backgroundColor={fields?.backgroundColor}
      className={componentclass}
      id={id}
      role="region"
      aria-label="Promo Hero"
    >
      <Content>
        <CopyDiv>
          <div className="inner">
            {topHeading && (
              <TopHeadingWrapper>
                <h1 dangerouslySetInnerHTML={{ __html: fields?.topHeading?.value || '' }} />
              </TopHeadingWrapper>
            )}
            {subHeading && (
              <SubHeadingWrapper>
                <Text field={fields?.subHeading} tag="p" />
              </SubHeadingWrapper>
            )}
            {copy && (
              <CopyWrapper>
                <RichText field={fields?.copy} tag="p" />
              </CopyWrapper>
            )}
            {button && (
              <Button
                field={fields?.button}
                path={fields?.button?.value?.url}
                href={fields?.button?.value?.href}
                type="default"
                target={fields?.button?.value?.target}
                text={fields?.button?.value?.text}
                variant="solidred"
                aria-label={fields?.button?.value?.text || 'Learn more'}
                {...fields?.button?.value}
              />
            )}
          </div>
        </CopyDiv>
        <MediaDiv>
          {foregroundImage?.value && (
            <img
              style={{ animationDelay: '0.5s' }}
              src={foregroundImage.value.src}
              alt={foregroundImage.value.alt}
            />
          )}
        </MediaDiv>
      </Content>
    </PromoHeroWrapper>
  );
};

PromoHero.propTypes = {
  fields: PropTypes.shape({
    topHeading: PropTypes.shape({ value: PropTypes.string }),
    subHeading: PropTypes.shape({ value: PropTypes.string }),
    copy: PropTypes.shape({ value: PropTypes.string }),
    button: PropTypes.object,
    backgroundImage: PropTypes.object,
  }),
  params: PropTypes.shape({
    backgroundColor: PropTypes.string,
    componentclass: PropTypes.string,
    id: PropTypes.string,
  }),
};

export default withSitecoreContext()(PromoHero);